import { render, staticRenderFns } from "./copy-draft.vue?vue&type=template&id=49ad3329"
import script from "./copy-draft.vue?vue&type=script&lang=js"
export * from "./copy-draft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports